<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách các điểm bán</h1>
      <strong class="text-primary pull-right"
        >Số lượng điểm bản hiển thị: {{ this.displayCount }} / Tổng số điểm bán trong phạm vi bản
        đồ: <span @click="newClickLimit">{{ this.pagination.total }}</span></strong
      >
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="clickSearch">
          <div class="clearfix row">
            <div class="col-md-2">
              <div class="line">
                <Select2
                  v-model="search.cityCode"
                  :options="dataProvince"
                  @change="changeProvince(search.cityCode)"
                  placeholder="Tỉnh/Thành phố"
                />
              </div>
              <div class="line mt-2">
                <Select2
                  v-model="search.districtCode"
                  :options="dataDistrict"
                  @change="changeDistrict"
                  placeholder="Quận/Huyện"
                />
              </div>
            </div>
            <div class="col-md-10">
              <div class="clearfix">
                <div class="form-group">
                  <input
                    @change="clickSearch"
                    type="text"
                    v-model.trim="search.textSearch"
                    class="form-control f12 hc-37"
                    placeholder="Từ khóa"
                  />
                </div>

                <div class="form-group">
                  <Select2
                    @change="clickSearch"
                    v-model="search.mcc"
                    :options="dataConfigMcc"
                    placeholder="Ngành hàng"
                  />
                </div>

                <div class="form-group">
                  <Select2
                    @change="clickSearch"
                    v-model="search.searchServiceType"
                    :options="dataConfigService"
                    placeholder="Dịch vụ"
                    multiple="multiple"
                  />
                </div>
                <div class="form-group col-100">
                  <input
                    @change="clickSearch"
                    type="text"
                    v-model.trim="search.limit"
                    class="form-control f12 hc-37"
                    placeholder="Giới hạn số Merchant"
                  />
                </div>
              </div>
              <div class="clearfix">
                <div class="form-group">
                  <button
                    type="button"
                    @click="gotoPinLogin"
                    class="btn btn-outline-light hc-37 mr-2 w220"
                    data-toggle="tooltip"
                    data-placement="top"
                  >
                    <i class="bx bx-map-pin" v-if="!loadingGeo"></i>
                    <i class="bx bx-loader" v-if="loadingGeo"></i>
                    <span>&nbsp;</span>Pin vào vị trí hiện tại
                  </button>
                </div>
                <div class="form-group">
                  <button
                    type="button"
                    @click="gotoPinSave"
                    class="btn btn-outline-light hc-37 mr-2 w220"
                    data-toggle="tooltip"
                    data-placement="top"
                  >
                    <i class="bx bx-map" v-if="!loadingGoto"></i>
                    <i class="bx bx-loader" v-if="loadingGoto"></i>
                    <span>&nbsp;</span>Đến "Pin của tôi"
                  </button>
                </div>
                <div class="form-group">
                  <button
                    type="button"
                    @click="savePin"
                    class="btn btn-outline-light hc-37 mr-2 w220"
                    data-toggle="tooltip"
                    data-placement="top"
                  >
                    <i class="bx bx-save" v-if="!loadingSave"></i>
                    <i class="bx bx-loader" v-if="loadingSave"></i>
                    <span>&nbsp;</span>Lưu vào "Pin của tôi"
                  </button>
                </div>
                <div class="form-group mgt10">
                  <input
                    type="checkbox"
                    @change="clickSearch"
                    v-model="search.is_auto_refresh"
                    class="float-left wauto mr-2"
                  />
                  Auto Refresh
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="card-body" v-if="dataPermission && dataPermission.includes('CNPS_CSTM_VIEW_MAP')">
        <div class="col-md-12 text-center" v-if="loading">
          <i class="bx bx-loader-circle bx-spin bx-rotate-90" style="font-size: 5em"></i>
        </div>
        <div class="tab-content">
          <div class="table-responsive">
            <div class="col-md-8 pull-left">
              <div class="box-maps">
                <GmapMap
                  @click="clickMap"
                  :clickable="true"
                  ref="map"
                  :center="markersCenter"
                  :zoom="12"
                  style="width: 100%; height: 500px"
                  :options="{
                    gestureHandling: 'greedy',
                    zoomControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                  }"
                  @dragend="dragMap"
                  @center_changed="dragMapGetCenter($event)"
                  :draggable="true"
                  @bounds_changed="boundsChanged($event)"
                >
                  <!-- Them cluters thi GmapCluster bao ngoai the  GmapMarker-->
                  <GmapMarker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :icon="{ url: require(`${m.icon}`), scaledSize: { width: 25, height: 38 } }"
                    @click="toggleInfo(m, index)"
                    :clickable="true"
                    :draggable="false"
                  />

                  <!-- PIN CENTER -->
                  <gmap-marker
                    :position="markersCenter"
                    :icon="{ url: require(`./icon/pin.png`) }"
                    :draggable="false"
                    @dragend="getMarkerPosition($event)"
                  ></gmap-marker>

                  <!-- POPUP -->
                  <gmap-info-window
                    :options="infoOptions"
                    :position="infoWindowPos"
                    :opened="infoWinOpen"
                    @closeclick="infoWinOpen = false"
                  >
                    <div v-html="infoContent"></div>
                  </gmap-info-window>

                  <!-- BORDER -->
                  <GmapCircle
                    @center_changed="centerChanged"
                    :center="markersCenter"
                    :radius="radiusMap"
                    :visible="true"
                    :options="{
                      strokeOpacity: 0.1,
                      fillOpacity: 0.1,
                      strokeColor: '#74ae49',
                    }"
                  ></GmapCircle>
                </GmapMap>
              </div>
            </div>
            <div class="col-md-4 pull-left">
              <div class="box-icons">
                <div class="itm-one" v-for="(item, index) in dataConfigMccIcon" :key="index">
                  <img :src="require(`${item.img}`)" alt="" /> {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { LocmapService } from '@/services/locmap.service'
  import { CommonService } from '@/services/common.service'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import Config from '../../thirdParty/config'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import { SalesManagerService } from '@/services/sales-manager.service'
  // import GmapCluster from 'vue2-google-maps/dist/components/cluster'
  import { TrackingService } from '@/services/tracking.service'
  import { GOOGLE_API_TOKEN } from '@/env.js'

  export default {
    components: {
      // GmapCluster
    },
    data() {
      return {
        loading: true,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        listAfterSale: Config.listAfterSale,
        dataMerchant: [],
        dataProvince: [],
        dataDistrict: [],
        search: {
          limit: 50,
          page: 1,
          latitudeStart: Config.positionNexttechBounds.latitudeStart,
          latitudeEnd: Config.positionNexttechBounds.latitudeEnd,
          longitudeStart: Config.positionNexttechBounds.longitudeStart,
          longitudeEnd: Config.positionNexttechBounds.longitudeEnd,
          is_auto_refresh: true,
        },
        pagination: {
          total: 0,
        },
        displayCount: 0,
        dataConfigService: [],
        dataConfigMcc: [],
        // Begin Map
        isRefreshing: false,
        locationCenterSearch: null,
        updateCenter: {
          lat: Config.positionNexttech.lat,
          lng: Config.positionNexttech.lng,
        },
        markersCenter: {
          lat: Config.positionNexttech.lat,
          lng: Config.positionNexttech.lng,
        },
        markers: [],
        dataMarkers: [],
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0,
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
        },
        radius: 2,
        radiusMap: 2000,
        dataPolygonByLatlng: [],
        loadingSave: false,
        loadingGoto: false,
        loadingGeo: false,
        navigatorPosition: {
          lat: null,
          lng: null,
        },
        // End Map
        dataConfigMccIcon: [
          { img: './icon/BAN_LE.svg', name: 'BÁN LẺ' },
          { img: './icon/BAO_HIEM.svg', name: 'BẢO HIỂM' },
          { img: './icon/CO_KHI_XAY_DUNG.svg', name: 'CƠ KHÍ - XÂY DỰNG' },
          { img: './icon/DICH_VU.svg', name: 'DỊCH VỤ' },
          { img: './icon/DICH_VU_CONG_N.G.O.svg', name: 'DỊCH VỤ CÔNG - N.G.O' },
          { img: './icon/DICH_VU_GIAI_TRI.svg', name: 'DỊCH VỤ GIẢI TRÍ' },
          { img: './icon/DIEN_TU_CONG_NGHE.svg', name: 'ĐIỆN TỬ - CÔNG NGHỆ' },
          { img: './icon/DU_LICH.svg', name: 'DU LỊCH' },
          { img: './icon/DV_VAN_TAI.svg', name: 'DV VẬN TẢI' },
          { img: './icon/FITNESS.svg', name: 'YOGA - FITNESS' },
          { img: './icon/GIAO_DUC_DAO_TAO.svg', name: 'GIÁO DỤC - ĐÀO TẠO' },
          { img: './icon/KHACH_SAN.svg', name: 'KHÁCH SẠN - LƯU TRÚ' },
          { img: './icon/NHA_HANG.svg', name: 'NHÀ HÀNG' },
          { img: './icon/KHACH_SAN.svg', name: 'NỘI THẤT' },
          { img: './icon/OTO_XE_MAY_XE_DAP.svg', name: 'Ô TÔ - XE MÁY' },
          { img: './icon/THAM_MY.svg', name: 'SPA - THẨM MỸ' },
          { img: './icon/THOI_TRANG_MY_PHAM.svg', name: 'THỜI TRANG - MỸ PHẨM' },
          { img: './icon/XANG_DAU_KHI_DOT.svg', name: 'XĂNG DẦU - KHÍ ĐỐT' },
          { img: './icon/Y_TE.svg', name: 'Y TẾ' },
          { img: './icon/OTHER.svg', name: 'KHÁC' },
        ],
        borders: [],
      }
    },
    mixins: [prepareQueryParamsMixin],
    filters: {
      transfromRegion(data, dataConfigRegion) {
        const dataReturn = dataConfigRegion.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
    },
    created() {
      this.locationCenterSearch = this.markersCenter
      const geoSearch = localStorage.getItem('geoSearch' + this.dataUser.userId)
      if (geoSearch !== '' && geoSearch !== undefined && geoSearch !== null) {
        this.search = JSON.parse(geoSearch)
      }
      this.suggestLocation()
      this.refresh_map(true)
      this.configSystem()
      this.myPinSave()
      this.myPinLogin()
    },
    computed: {
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataSearch: 'search/getDataSearchOther',
      }),
    },
    methods: {
      loadLimit() {
        if (this.search.limit === '' || this.search.limit === 0) {
          this.search.limit = 50
        }
      },
      removeUnit() {
        delete this.search.cityCode
        delete this.search.districtCode
      },
      removeBox() {
        delete this.search.mcc
        delete this.search.textSearch
        delete this.search.searchServiceType
      },
      newClickLimit() {
        this.search.limit = this.pagination.total
      },
      async myPinSave() {
        const pinSave = localStorage.getItem('pinSave' + this.dataUser.userId)
        if (pinSave === '' || pinSave === undefined || pinSave === null) {
          const _pinSave = {
            lat: Config.positionNexttech.lat,
            lng: Config.positionNexttech.lng,
          }
          localStorage.setItem('pinSave' + this.dataUser.userId, JSON.stringify(_pinSave))
        }
      },
      async myPinLogin() {
        const pinLogin = localStorage.getItem('pinLogin' + this.dataUser.userId)
        if (pinLogin === '' || pinLogin === undefined || pinLogin === null) {
          await navigator.geolocation.getCurrentPosition(
            position => {
              const tmpPinLogin = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              }
              localStorage.setItem('pinLogin' + this.dataUser.userId, JSON.stringify(tmpPinLogin))
            },
            error => {
              this.error = error
            }
          )
        }
      },
      async suggestLocation() {
        try {
          this.loading = true
          const params = { adminLocations: this.dataUser.adminLocations }
          const { data } = await TrackingService.getProvince(params)
          const datas = [
            {
              id: '1',
              _id: '',
              text: 'Tất cả',
              code: '',
              latitude: this.markersCenter.lat,
              longitude: this.markersCenter.lng,
            },
          ]
          if (data.length > 0) {
            data.map(e => {
              const body = {
                _id: e.id,
                id: e.code,
                code: e.code,
                text: e.prefix + ' ' + e.name,
                latitude: parseFloat(e.latitude),
                longitude: parseFloat(e.longitude),
              }
              datas.push(body)
            })
            this.dataProvince = datas
          } else {
            this.dataProvince = []
          }
        } catch (e) {
          this.error = e.message
        } finally {
          this.loading = false
        }
      },
      async clickSearch() {
        this.loadLimit()
        this.removeUnit()
        localStorage.setItem('geoSearch' + this.dataUser.userId, JSON.stringify(this.search))
        this.refresh_map(true)
      },
      async fetchData() {
        try {
          this.centerChanged()
          this.search.userId = this.dataUser.userId
          delete this.search.cityCode
          delete this.search.districtCode
          if (this.search.mcc === '0') delete this.search.mcc
          if (this.search.searchServiceType === '0') delete this.search.searchServiceType

          this.setMapApi()

          const data = await LocmapService.getDataLocList(this.search)
          if (data.code === 1000) {
            this.dataMerchant = data.data
            this.pagination.total = data.meta.pagination.total ? data.meta.pagination.total : 0
            this.displayCount = data.meta.pagination.displayCount
              ? data.meta.pagination.displayCount
              : 0
            // Begin Map
            this.dataMarkers = []
            data.data.map(async (item, index) => {
              /*
              const dataAddress = await this.getAddressFrom(parseFloat(item.latitude), parseFloat(item.longitude))
              if (this.dataMerchant.length > 0) {
                this.dataMerchant[index].address = dataAddress
              }
              */
              this.dataMerchant[index].address = item.areaAddress
              const body = {
                areaName: item.areaName,
                name: item.merchantName,
                mobile: item.mobile,
                email: item.email,
                address: item.areaAddress,
                position: {
                  lat: parseFloat(item.latitude),
                  lng: parseFloat(item.longitude),
                },
                appOnForeground: true,
                icon: item.mcc ? './icon/' + item.mcc + '.svg' : './icon/no.png',
                mcc: item.mcc,
                customerId: item.customerId,
              }
              this.dataMarkers.push(body)
            })
            // End Map
          }
        } catch (error) {
        } finally {
          this.loading = false
        }
      },
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.dataConfigService.push({ id: 0, text: 'Tất cả' })
              data.data.services.map(e => this.dataConfigService.push({ id: e.code, text: e.name }))
              this.getListService()
              this.dataConfigMcc.push({ id: 0, text: 'Tất cả' })
              data.data.businessFields.map(e =>
                this.dataConfigMcc.push({ id: e.code, text: e.name })
              )
            }
          })
          .catch(error => {
            this.error = error.message
          })
      },
      async getListService() {
        try {
          const response = await SalesManagerService.getGroupService({})
          if (response.code === 1000) {
            this.dataGroupService = response.data.groupService
            const data = this.dataGroupService.filter(e => e.service === 'SELL')
            if (data[0].detail.length > 0) {
              data[0].detail.map(e => {
                const body = {
                  id: e.code,
                  text: this.serviceTypes(e.name),
                }
                this.dataConfigService.push(body)
              })
            }
          }
        } catch (error) {}
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
      // Map
      async clickMap(event) {
        this.markers = []
        this.markersCenter.lat = event.latLng.lat()
        this.markersCenter.lng = event.latLng.lng()
        this.refresh_map(this.search.is_auto_refresh)
      },
      // @idle
      async dragMap() {
        this.markers = []
        this.markersCenter.lat = this.updateCenter.lat()
        this.markersCenter.lng = this.updateCenter.lng()
        this.refresh_map(this.search.is_auto_refresh)
      },
      dragMapGetCenter(event) {
        this.updateCenter = event
      },
      centerChanged(e) {
        const EARTH_RADIUS = 6378137
        const arrayLat = []
        const arrayLng = []

        const lat = e ? e.lat() : (this.markersCenter.lat * Math.PI) / 180.0
        const lon = e ? e.lng() : (this.markersCenter.lng * Math.PI) / 180.0

        for (let index = 0; index < Math.PI * 2; index += 0.3) {
          const latPoint = lat + (this.radiusMap / EARTH_RADIUS) * Math.sin(index)
          const lonPoint = lon + ((this.radiusMap / EARTH_RADIUS) * Math.cos(index)) / Math.cos(lat)
          arrayLat.push((latPoint * 180.0) / Math.PI)
          arrayLng.push((lonPoint * 180.0) / Math.PI)
        }

        this.borders.latitudeStart = Math.min(...arrayLat).toString()
        this.borders.longitudeStart = Math.min(...arrayLng).toString()
        this.borders.latitudeEnd = Math.max(...arrayLat).toString()
        this.borders.longitudeEnd = Math.max(...arrayLng).toString()
        this.borders.latitudeCenter = this.markersCenter.lat.toString()
        this.borders.longitudeCenter = this.markersCenter.lng.toString()
        this.borders.radius = this.radiusMap / 1000
      },
      toggleInfo(marker, idx) {
        this.infoWindowPos = marker.position
        this.infoContent = this.getInfoWindowContent(marker)

        if (this.currentMidx === idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
      },
      getInfoWindowContent(marker) {
        return (
          '<div>Tên MC: <b>' +
          (marker.name ? marker.name : '') +
          '</b></div>' +
          '<div> Địa chỉ: <b>' +
          (marker.address ? marker.address : '') +
          '</b></div>' +
          '<div>Ngành hàng: <b>' +
          (marker.mcc ? this.transfromMccName(marker.mcc, this.dataConfigMcc) : '') +
          '</b></div>' +
          '<div style="margin-top: 5px"><a target="_blank" href="list-mc/' +
          marker.customerId +
          '">Xem chi tiết</a></div>'
        )
      },
      changeCenterProvince() {
        if (this.search.cityCode === '1') {
          this.search.cityCode = null
          this.search.districtCode = null
        }

        const provinceSelected = this.dataProvince.filter(e => e.code === this.search.cityCode)
        if (provinceSelected.length > 0) {
          this.locationCenterSearch = {
            lat: provinceSelected[0].latitude,
            lng: provinceSelected[0].longitude,
          }
        } else {
          this.markersCenter = {
            lat: Config.positionNexttech.lat,
            lng: Config.positionNexttech.lng,
          }
        }
      },
      async getAddressFrom(lat, long) {
        let data = ''
        await axios
          .get(
            'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
              lat +
              ',' +
              long +
              `&key=${GOOGLE_API_TOKEN}`
          )
          .then(response => {
            data = response.data.results[0] ? response.data.results[0].formatted_address : ''
          })
          .catch(error => {
            this.error = error.message
          })
        return data
      },
      async getMarkerPosition(location) {
        this.coordinates = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng(),
        }
        this.markersCenter = this.coordinates
      },
      transfromMccName(data, dataConfigMcc) {
        const dataReturn = dataConfigMcc.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
      changeDistrict() {
        const districtSelected = this.dataDistrict.filter(e => e.code === this.search.districtCode)
        if (districtSelected.length > 0) {
          this.locationCenterSearch = {
            lat: districtSelected[0].latitude,
            lng: districtSelected[0].longitude,
          }
          this.markersCenter = this.locationCenterSearch
          this.removeBox()
          localStorage.setItem('geoSearch' + this.dataUser.userId, JSON.stringify(this.search))
          this.refresh_map(true)
        }
      },
      async changeProvince(codeProvince) {
        this.changeCenterProvince()
        this.removeBox()
        localStorage.setItem('geoSearch' + this.dataUser.userId, JSON.stringify(this.search))
        this.dataProvince.forEach(e => {
          if (e.code === codeProvince) {
            this.params = { codeCity: e.code }
          }
        })
        try {
          if (codeProvince === '' || codeProvince === '1') {
            this.dataDistrict = []
            this.locationCenterSearch = {
              lat: Config.positionNexttech.lat,
              lng: Config.positionNexttech.lng,
            }
          }

          this.markersCenter = this.locationCenterSearch

          this.refresh_map(true)

          const datas = []
          const { data } = await TrackingService.getDistrict(this.params)
          if (data.length > 0) {
            data.map(e => {
              const body = {
                code: e.code,
                id: e.code,
                _id: e.id,
                text: e.prefix + ' ' + e.name,
                latitude: parseFloat(e.latitude),
                longitude: parseFloat(e.longitude),
              }
              datas.push(body)
            })
            this.dataDistrict = datas
          } else {
            this.dataDistrict = []
          }
        } catch (e) {
          this.error = e.message
        }
      },
      async savePin() {
        this.loadingSave = true
        await localStorage.setItem(
          'pinSave' + this.dataUser.userId,
          JSON.stringify(this.markersCenter)
        )
        await this.sleep(200)
        this.loadingSave = false
        return false
      },
      async gotoPinSave() {
        this.removeUnit()
        this.loadingGoto = true
        const pin = localStorage.getItem('pinSave' + this.dataUser.userId)
        if (pin !== '' && pin !== undefined && pin !== null) {
          this.markersCenter = JSON.parse(pin)
          this.refresh_map(true)
        }
        await this.sleep(200)
        this.loadingGoto = false
        return false
      },
      async gotoPinLogin() {
        this.removeUnit()
        this.loadingGeo = true
        const pinLogin = localStorage.getItem('pinLogin' + this.dataUser.userId)
        if (pinLogin !== '' && pinLogin !== undefined && pinLogin !== null) {
          this.markersCenter = JSON.parse(pinLogin)
          this.refresh_map(this.search.is_auto_refresh)
        }
        await this.sleep(200)
        this.loadingGeo = false
        return false
      },
      async refresh_map(isLoadData) {
        this.draw_map()
        if (isLoadData === true) {
          if (!this.isRefreshing) {
            this.isRefreshing = true
            await this.fetchData()
            this.draw_map()
            this.isRefreshing = false
          }
        }
      },
      sleep(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms)
        })
      },
      draw_map() {
        this.markers = null
        this.markers = this.dataMarkers
      },
      boundsChanged(event) {
        if (event !== undefined) {
          const lat_n = event.getNorthEast().lat()
          const lng_n = event.getNorthEast().lng()

          const lat_s = event.getSouthWest().lat()
          const lng_s = event.getSouthWest().lng()

          const arrayLat = [lat_n, lat_s]
          const arrayLng = [lng_n, lng_s]

          this.search.latitudeStart = Math.min(...arrayLat).toString()
          this.search.longitudeStart = Math.min(...arrayLng).toString()
          this.search.latitudeEnd = Math.max(...arrayLat).toString()
          this.search.longitudeEnd = Math.max(...arrayLng).toString()
        }
      },
      setMapApi() {
        const map_width =
          parseFloat(this.search.longitudeEnd) - parseFloat(this.search.longitudeStart)
        const map_height =
          parseFloat(this.search.latitudeEnd) - parseFloat(this.search.latitudeStart)

        this.search.latitudeEnd = parseFloat(this.search.latitudeStart) + map_height * 0.95
        this.search.latitudeStart = parseFloat(this.search.latitudeStart) + map_height * 0.05
        this.search.longitudeEnd = parseFloat(this.search.longitudeStart) + map_width * 0.95
        this.search.longitudeStart = parseFloat(this.search.longitudeStart) + map_width * 0.05
      },
    },
  }
</script>
<style scoped>
  .box-maps {
    width: 99.5%;
  }
  .w220 {
    width: 200px;
  }
  .wauto {
    width: auto;
  }
  .mgt10 {
    margin-top: 10px;
  }
  .itm-one {
    display: inline-block;
    width: 45%;
    float: left;
    margin: 0 2px 20px;
  }
</style>
